module.exports = __webpack_public_path__ + "img/man_2_iocn.70d16eb6.png";